import { useEffect, useState } from 'react';
import { FundTypeSelectorOption } from './FundTypeSelectorOptionsContext';

export const useSelectedFundTypeState = (
  fundTypeOptions: Array<FundTypeSelectorOption>,
) => {
  const [selectedFundTypes, setSelectedFundTypes] = useState<Array<string>>([]);

  const allFundsSelected = fundTypeOptions.every((fundType) =>
    selectedFundTypes.includes(fundType.key),
  );

  const selectedFundTypeTagIds = fundTypeOptions
    .filter((label) => selectedFundTypes.includes(label.key))
    .map((label) => label.tagId);

  useEffect(() => {
    setSelectedFundTypes(fundTypeOptions.map((label) => label.key));
  }, [fundTypeOptions]);

  return {
    allFundsSelected,
    setSelectedFundTypes,
    selectedFundTypeTagIds,
    selectedFundTypes,
  };
};
